import type { Befund, Operation, Status } from "@gui-creator/gemeinsam";
import { ApiFehler } from "../api/klient.ts";

export type Antwort = { revision: number; status?: Status; befunde: Befund[] };
export type Ergebnis = "ok" | "ui_weg" | "abgemeldet" | "offline" | "abgelehnt";
type Sender = (ui: string, ops: Operation[]) => Promise<Antwort>;

/** Hält Änderungen in Reihenfolge, bis der Server sie angenommen hat; überlebt Abmeldung und Netzausfall. */
export class Puffer {
  private eintraege: { ui: string; ops: Operation[] }[] = [];
  private lauf: Promise<Ergebnis> | null = null;
  letzterFehler: string | null = null;
  abgelehntFuer: string | null = null;
  private besitzer: string | null = null;

  /** Bindet den Puffer an ein Konto; meldet sich ein anderes an, werden fremde Änderungen verworfen. */
  besitzerSetzen(konto: string): number {
    const verworfen = this.besitzer !== null && this.besitzer !== konto ? this.eintraege.length : 0;
    if (verworfen) this.eintraege = [];
    this.besitzer = konto;
    return verworfen;
  }

  hinzu(ui: string, ops: Operation[]): void {
    if (ops.length) this.eintraege.push({ ui, ops });
  }

  leer(): boolean {
    return this.eintraege.length === 0;
  }

  anzahl(): number {
    return this.eintraege.length;
  }

  ausstehendFuer(ui: string): boolean {
    return this.eintraege.some((e) => e.ui === ui);
  }

  opsFuer(ui: string): Operation[][] {
    return this.eintraege.filter((e) => e.ui === ui).map((e) => e.ops);
  }

  senden(sende: Sender, beiAntwort?: (ui: string, a: Antwort) => void): Promise<Ergebnis> {
    this.lauf ??= this.abarbeiten(sende, beiAntwort).finally(() => {
      this.lauf = null;
    });
    return this.lauf;
  }

  private async abarbeiten(sende: Sender, beiAntwort?: (ui: string, a: Antwort) => void): Promise<Ergebnis> {
    while (this.eintraege.length) {
      const e = this.eintraege[0]!;
      try {
        const a = await sende(e.ui, e.ops);
        this.eintraege.shift();
        beiAntwort?.(e.ui, a);
      } catch (f) {
        const status = f instanceof ApiFehler ? f.status : 0;
        this.letzterFehler = (f as Error).message;
        if (status === 0 || status >= 500) return "offline";
        if (status === 401) return "abgemeldet";
        if (status === 404) {
          this.eintraege = this.eintraege.filter((x) => x.ui !== e.ui);
          return "ui_weg";
        }
        this.eintraege.shift();
        this.abgelehntFuer = e.ui;
        return "abgelehnt";
      }
    }
    return "ok";
  }
}

export const puffer = new Puffer();
